const {
  EXPERIMENT_COLLECT_METRICS,
  EXPERIMENT_USE_CUSTOM_ROUTER,
  EXPERIMENT_USE_SITE_QUERY_SERVICE,
  EXPERIMENT_VALIDATE_VIEW_MODE,
  EXPERIMENT_USE_NEXT_RCE,
  EXPERIMENT_VIEWER_RC_VERSION,
  EXPERIMENT_DEV_OOI,
  EXPERIMENT_HASHTAG_PAGE_USE_FEED_PAGE,
  EXPERIMENT_USE_NEW_WIX_SDK,
  EXPERIMENT_CUSTOM_FEED_ML_HACK,
  EXPERIMENT_CUSTOM_URL,
  EXPERIMENT_USE_CATEGORY_WIDGET_ADAPTER_IN_EDITOR,
  EXPERIMENT_USE_TAG_CLOUD_WIDGET_ADAPTER_IN_EDITOR,
  EXPERIMENT_USE_ARCHIVE_WIDGET_ADAPTER_IN_EDITOR,
  EXPERIMENT_CTA_IN_AMP_HEADER,
} = require('@wix/communities-blog-experiments');

const isExperimentEnabled =
  (experiment, value = 'true') =>
  (experiments) =>
    experiments[experiment] === value;

const isCollectMetricsExperimentEnabled = isExperimentEnabled(EXPERIMENT_COLLECT_METRICS);
const isUseCustomRouterExperimentEnabled = isExperimentEnabled(EXPERIMENT_USE_CUSTOM_ROUTER);
const isUseSiteQueryServiceExperimentEnabled = isExperimentEnabled(EXPERIMENT_USE_SITE_QUERY_SERVICE);
const isViewModeValidationEnabled = isExperimentEnabled(EXPERIMENT_VALIDATE_VIEW_MODE);
const isUseNextRceExperimentEnabled = isExperimentEnabled(EXPERIMENT_USE_NEXT_RCE);
const isViewerRCVersionExperimentEnabled = isExperimentEnabled(EXPERIMENT_VIEWER_RC_VERSION);
const isDevOOIExperimentEnabled = isExperimentEnabled(EXPERIMENT_DEV_OOI);
const isHashtagPageAsFeedPageExperimentEnabled = isExperimentEnabled(EXPERIMENT_HASHTAG_PAGE_USE_FEED_PAGE);
const isCustomFeedMLHackExperimentEnabled = isExperimentEnabled(EXPERIMENT_CUSTOM_FEED_ML_HACK);
const isUseNewWixSdkEnabled = isExperimentEnabled(EXPERIMENT_USE_NEW_WIX_SDK);
const isCustomUrlExperimentEnabled = isExperimentEnabled(EXPERIMENT_CUSTOM_URL);
const isUseCatergoryWidgetAdapterExperimentEnabled = isExperimentEnabled(
  EXPERIMENT_USE_CATEGORY_WIDGET_ADAPTER_IN_EDITOR,
);
const isUseTagCloudWidgetAdapterExperimentEnabled = isExperimentEnabled(
  EXPERIMENT_USE_TAG_CLOUD_WIDGET_ADAPTER_IN_EDITOR,
);
const isUseArchiveWidgetAdapterExperimentEnabled = isExperimentEnabled(EXPERIMENT_USE_ARCHIVE_WIDGET_ADAPTER_IN_EDITOR);
const isCTAinAMPHeaderExperimentEnabled = isExperimentEnabled(EXPERIMENT_CTA_IN_AMP_HEADER);

module.exports = {
  isExperimentEnabled,
  isCollectMetricsExperimentEnabled,
  isUseCustomRouterExperimentEnabled,
  isUseSiteQueryServiceExperimentEnabled,
  isViewModeValidationEnabled,
  isUseNextRceExperimentEnabled,
  isHashtagPageAsFeedPageExperimentEnabled,
  isViewerRCVersionExperimentEnabled,
  isDevOOIExperimentEnabled,
  isUseNewWixSdkEnabled,
  isCustomFeedMLHackExperimentEnabled,
  isCustomUrlExperimentEnabled,
  isUseCatergoryWidgetAdapterExperimentEnabled,
  isUseTagCloudWidgetAdapterExperimentEnabled,
  isUseArchiveWidgetAdapterExperimentEnabled,
  isCTAinAMPHeaderExperimentEnabled,
};
